import { Metric } from "../Metric";
import { fmt } from "../../lib/api";
import { percentile, groupStats } from "../../lib/reports";

export const ReportKpis = ({ tests }) => {
  const dl = tests.map((t) => t.download_mbps);
  const ul = tests.map((t) => t.upload_mbps);
  const ping = tests.map((t) => t.ping_ms);
  const issueN = tests.filter((t) => t.issues.length).length;
  const teams = groupStats(tests, (t) => t.team).sort((a, b) => b.dl - a.dl);
  const reps = new Set(tests.map((t) => t.rep_name)).size;
  const gps = tests.filter((t) => t.location?.source === "gps").length;
  const pct = (n) => (tests.length ? `${Math.round((n / tests.length) * 100)}%` : "—");
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 border-l border-white/10" data-testid="report-kpis">
      <Metric testId="rk-tests" label="Tests" value={tests.length} unit={`${reps} reps`} />
      <Metric testId="rk-healthy" label="Healthy rate" value={pct(tests.length - issueN)} />
      <Metric testId="rk-issue-rate" label="Issue rate" value={pct(issueN)} bad={issueN > 0} />
      <Metric testId="rk-median-dl" label="Median ↓" unit="Mbps" value={fmt(percentile(dl, 50))} />
      <Metric testId="rk-p10-dl" label="Worst 10% ↓" unit="Mbps" value={fmt(percentile(dl, 10))} />
      <Metric testId="rk-peak-dl" label="Peak ↓" unit="Mbps" value={fmt(percentile(dl, 100))} />
      <Metric testId="rk-median-ul" label="Median ↑" unit="Mbps" value={fmt(percentile(ul, 50))} />
      <Metric testId="rk-median-ping" label="Median ping" unit="ms" value={fmt(percentile(ping, 50), 0)} />
      <Metric testId="rk-p90-ping" label="Worst 10% ping" unit="ms" value={fmt(percentile(ping, 90), 0)} />
      <Metric testId="rk-best-team" label="Best province" value={teams[0]?.key || "—"} />
      <Metric testId="rk-worst-team" label="Weakest province" value={teams.length > 1 ? teams[teams.length - 1].key : "—"} bad={teams.length > 1} />
      <Metric testId="rk-gps" label="GPS located" value={pct(gps)} />
    </div>
  );
};
